import { ReadActionCreators, ReadActionTypes } from './types';

export const fetchReadRequest = (): ReadActionCreators => {
  return { type: ReadActionTypes.FETCH_READS_REQUEST };
};

export const fetchReadSuccess = (tilstandsrapportId, sjekkpunktIds): ReadActionCreators => {
  return { type: ReadActionTypes.FETCH_READS_SUCCESS, tilstandsrapportId, sjekkpunktIds };
};

export const fetchReadFailure = (error: Error): ReadActionCreators => {
  return { type: ReadActionTypes.FETCH_READS_FAILURE, error };
};

export const sjekkpunktReadSuccess = (tilstandsrapportId, id): ReadActionCreators => {
  return { type: ReadActionTypes.SET_SJEKKPUNKT_READ, id };
};

export const doFetchReads = (analyseId: string) => {
  return async (dispatch): Promise<void> => {
    dispatch(fetchReadRequest());
    try {
      const sjekkpunktIds = JSON.parse(localStorage.getItem(`reads_${analyseId}`)) as { [id: string]: boolean };
      dispatch(fetchReadSuccess(analyseId, sjekkpunktIds));
    } catch (err) {
      dispatch(fetchReadFailure(err));
    }
  };
};

export const doMarkSjekkpunktAsRead = (tilstandsrapportId, id) => {
  return async (dispatch): Promise<void> => {
    try {
      const sjekkpunktIds = JSON.parse(localStorage.getItem(`reads_${tilstandsrapportId}`)) as {
        [id: string]: boolean;
      };
      if (sjekkpunktIds) {
        localStorage.setItem(`reads_${tilstandsrapportId}`, JSON.stringify({ ...sjekkpunktIds, [id]: true }));
      } else {
        localStorage.setItem(`reads_${tilstandsrapportId}`, JSON.stringify({ [id]: true }));
      }
      dispatch(sjekkpunktReadSuccess(tilstandsrapportId, id));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(`Error marking sjekkpunkt as read: Tilstandsrapport ${tilstandsrapportId}, id: ${id}`, err);
    }
  };
};
